import type { ProgressDialogHandle, ProgressDialogOptions } from "./progress.model";

/**
 * Abstract base for a progress-dialog service.
 *
 * Each application provides its own concrete implementation
 * (e.g. PrimeNG-based in the frontend, or a no-op in the Excel Add-In).
 * The singleton is stored on this base class so that the shared
 * {@link reportProgress} operator can use it without knowing the concrete type.
 */
export abstract class ProgressDialogServiceBase {
  static instance: ProgressDialogServiceBase | null = null;

  abstract open(title: string, progressId: string, options?: ProgressDialogOptions): ProgressDialogHandle;
  abstract close(): void;
}
